import React, {useCallback, useContext, useEffect, useMemo, useState} from 'react'
import {useDispatch} from 'react-redux'
import {AppContext} from '../../../App'
import AddAlertIcon from '../../../assets/icons/AddAlertIcon'
import {ListItemIcon, ListItemText} from '@mui/material'
import {setAlertModalData} from '../../../reducer/alerts.reducer'
import {createUserAlertFromSnapshot} from '../../../util/alerts'
import AnalyticsManager from '../../../analytics/AnalyticsManager'
import {useUser} from '../../../context/UserContext'
import {FeatureCategory, FeatureSubCategory} from '../../adminUserRestrictions/Restrictions.constants'
import {Group, setFeatureRestrictionDialog} from '../../../reducer/user.reducer'
import { FeatureCode } from '../../../util/RestrictionFeatureCode'

interface AlertMenuItemProps {
    viewKey: string
    disabled?: boolean
    customPriceValue?: string
    handleCloseMenu: Function
    symbolName: string | undefined
}

function AlertContextMenuItem(props: AlertMenuItemProps) {
    const dispatch = useDispatch()
    const {viewKey, customPriceValue, handleCloseMenu, symbolName} = props
    const appContext = useContext(AppContext)
    const {user: {hasAccess}} = useUser()
    const chartSnapshot = useMemo(()=>{
        if(appContext?.getChartSnapshot?.[viewKey]) {
            return (appContext.getChartSnapshot[viewKey] as any)()
        }
        return undefined
    }, [appContext.getChartSnapshot, viewKey])
    const [price, setPrice] = useState(customPriceValue !== undefined ? Number(customPriceValue) : undefined)
    
    useEffect(()=>{
        if(chartSnapshot && !customPriceValue) {
            setPrice(chartSnapshot.data.close)
        }
    }, [chartSnapshot])

    const handleButtonClick = useCallback(() => {
        if(!hasAccess(FeatureCategory.CHART, FeatureSubCategory.ALERTS)) {
            dispatch(setFeatureRestrictionDialog({
                open: true,
                feature: "Alerts",
                group: Group.CHART,
                featureRestrictionCode:FeatureCode.CHART_ALERTS
            }))
            handleCloseMenu()
            return
        }
        
        AnalyticsManager.logEvent('Add Alert Clicked', {source: 'chart-grid'})
        const chartSnapshotMethod = appContext.getChartSnapshot[viewKey]
        const snapshot = chartSnapshotMethod ? chartSnapshotMethod() : null
        if (!snapshot) return
        if(price !== undefined) snapshot.data.close = Number(price)
        dispatch(setAlertModalData({
            chartSnapshot: snapshot,
            alert: createUserAlertFromSnapshot(snapshot),
            edit: false
        }))
        handleCloseMenu()
    }, [appContext.getChartSnapshot, viewKey, price, dispatch, handleCloseMenu, hasAccess])

    return (
        <>
            <ListItemIcon onClick={handleButtonClick}>
                <AddAlertIcon sx={{fontSize: '1.5rem !important'}}/>
            </ListItemIcon>
            <ListItemText onClick={handleButtonClick}>
                Add Alert on {symbolName ?? ''} at {customPriceValue??price}
            </ListItemText>
        </>
    )
}

export default React.memo(AlertContextMenuItem)